import React from "react";
import ReportWorkspace from "./ReportWorkspace";

const ReportInvoiceFull = props => <ReportWorkspace type="full" history={props.history} />;

export default ReportInvoiceFull;
